
import { makeStyles } from "@material-ui/core/styles";
import {logoMAS,microfoftLogo,bgImage,msgBg} from '../../../asset';

const loginStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
      },
      popUpOuter:{
        "& .Mui-disabled":{
         opacity: '0.6 !important',
         color: '#fff  !important',
        }, 
        "& .MuiDialog-paperWidthSm":{
         maxWidth: '600px',
         overflow: 'initial',
        },
        "& .MuiDialogTitle-root ":{
         flex: '0 0 auto',
         margin: '0',
         position: 'relative',
         padding: '16px 24px',
         //z-index: '1',
        },
        "& .MuiOutlinedInput-input":{
            float: 'left !important',
            width: '100% !important',
            padding: '10px 2px !important',
            background: '#f7fcff',
            borderRadius: '4px',
        },
 
     },
     popUpHeader:{
      backgroundImage: 'linear-gradient(to right, #890e34, #ce0623)',
      padding:'14px 12px 10px 24px !important',
      borderRadius:'0px 0px 0 0',
     "& h2":{
      color: '#fff',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      position: 'relative',
     },
  },

  NoPopWrapper:{
    padding: '20px 120px 20px 25px',
    "& .MuiOutlinedInput-input":{
       float: 'left',
       width: '100%',
       padding: '10px 0 10px 2px',
       background: '#f7fcff',
       borderRadius: '4px',
    },
    "& .MuiFormControl-root":{
       margin: '0 10px 0 0',
    },
},
popUpLBL:{
  textTransform:'uppercase',
  fontSize:'12px',
  margin:'0 2px 0 0',
},

greenBtnWrapper:{
  float: 'right',
margin: '-18px 0px 0 10px',
  "& button":{
      background: '#19C626 !important',
fontSize: '12px',
color: '#fff',
borderRadius: '20px',
  padding: '5px 17px 5px 12px',
  fontWeight:'bold',
},
"& .MuiButton-root:hover":{
  color: '#fff',
  fontSize: '12px',
  background: '#00b50a !important',
  borderRadius: '20px',
  padding: '5px 17px 5px 12px',
},


},
grayBtnWrapper:{
  float: 'right',
margin: '-18px 0px 0 10px',
  "& button":{
      background: '#333 !important',
fontSize: '12px',
color: '#fff',
borderRadius: '20px',
  padding: '5px 25px',
  fontWeight:'bold',
},
"& .MuiButton-root:hover":{
  background: '#333 !important',
  fontSize: '12px',
  color: '#fff',
  borderRadius: '20px',
  padding: '5px 25px',
},


},
      margin: {
        margin: theme.spacing(1),
      },
    logInPage:{
        display: 'flex',
       height: '100vh',
       },
       signInWrapper: {
           width: '100%',
           display: '-ms-flexbox',
           backgroundImage: `url("${bgImage}")`,
           backgroundRepeat: 'repeat-x',
           backgroundPosition: '50% 92%',
           position: 'relative',
           backgroundSize: 'cover',
           [theme.breakpoints.down('sm')]:{
            backgroundPosition: '62% 92%',
           },
       }, 
       bgWrapper: {
        backgroundImage: `url("${msgBg}")`,
        width: '1000px',
        bottom: '0',
        height: '598px',
        position: 'absolute',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        right: '0',
        opacity: '0.4',
        [theme.breakpoints.down('sm')]:{
        //  backgroundPosition: '62% 92%',
         
        },
    },  
    msgTxt:{
      color: '#ffffff',
      padding: '10px 10px 10px 10px',
      position: 'relative',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '20px',
      textTransform: 'uppercase',
      background: '#f50000',
      margin: '50px 0 0 0',
    },
    
          loginContentWrapper:{
            margin:'100px 0 0 70px',
            [theme.breakpoints.down('sm')]:{
              margin:'100px 0 0 40px',
             },
          },
          loginBtn:{
            "& .MuiButton-root":{
            border:'2px solid #c2c2c2 !important',
            padding:'12px 2px 12px 65px',
            backgroundImage: `url("${microfoftLogo}")`,
            backgroundRepeat:'no-repeat',
            width:'450px',
            borderRadius:'5px 5px 5px 5px',
            backgroundColor:'#fff',
            borderColor:'#a2a2a2',
            textAlign:'left',
            backgroundPosition: 'center left',
            fontSize:'16px',
            float:'left',
            [theme.breakpoints.down('sm')]:{
              width:'300px',
             },
          },
          },

          logoWrapper:{
             float:'left',
             width:'100%', 
          },
          loginPageLogo:{
           backgroundImage: `url("${logoMAS}")`,
            float:'left',
            width:'200px',
            height:'88px',
    
          },
          microfoftLogo:{
           // backgroundImage: `url("${microfoftLogo}")`,
            float:'left',
            width:'465px',
            height:'107px',
    
          },
          loginDataRowOne:{
            margin:'90px 0 50px 0',
            float:'left',
            textAlign:'left',
          },
          loginDataRowTwo:{
            margin:'5px 0 5px 0',
          },
          loginDataRowThree:{
            margin:'5px 0 50px 0',
          },
          TxtOne:{
            fontSize:'36px',
            fontWeight:'bold',
            color:'#535353',
            textTransform:'uppercase',
            width:'100%',
            float:'left',
          },
          TxtTwo:{
            fontSize:'26px',
            color:'#535353',
            width:'100%',
            float:'left',
            textTransform:'uppercase',
            [theme.breakpoints.down('sm')]:{
              fontSize:'24px',
             },
          },
          TxtTree:{
            fontSize:'20px',
            fontWeight:'bold',
            color:'#535353',
            textTransform:'uppercase',
          },
          inputWrapper: {
            margin:'10px 0 10px 0',
            "& .MuiInputBase-root":{
                borderRadius: '4px',
                        //border: '1px solid #c0c1c1',
                         padding: '0px 0',
                         width:'100%',
                         background:'#f7fcff',
                         float: 'left',
    
            },
            "& .MuiOutlinedInput-input":{
                padding:'12px 5px',
            },
            "& .MuiInput-root": {
                position: 'relative',
                width: '60%',
                border: '1px solid #ccc !important',
                borderRadius: '4px',
                padding: '4px 0 4px 4px',
                background:'#f7fcff',
                float: 'left',
            },
    
            "& .MuiTextField-root": {
    
                fontSize: '2px',
                background: '#fff',
                padding: '0 0 0 0',
                borderRadius: '5px',
                border: 'unset',
                margin: '2px',
                width: '90%',
                float:'left',
            },
            "& .MuiInput-underline:before": {
                borderBottom: 'unset',
            },
            "& .MuiInput-underline:after": {
                borderBottom: '1px solid #ccc',
            },
            "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
    
                padding: '0px 0 0 0',
            },
            "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input": {
    
                padding: '6px 4px',
                fontSize: '12px',
            },
            "& .makeStyles-filterSection-149 .MuiTextField-root": {
    
                border: '1px solid #333',
            },
            "& .makeStyles-root-139 .MuiIconButton-root": {
    
                padding: '0px 0',
                margin: '0px 0',
            },
            // "& input":{
            //              borderRadius: '4px',
            //              border: '1px solid #c0c1c1',
            //              padding: '8px 0',
            //              width:'100%',
            //             background:'#f7fcff',
            //              float: 'left',
            //          },
                    "& select":{
                         borderRadius: '4px',
                        border: '1px solid #c0c1c1',
                         padding: '12px 0',
                         width:'100%',
                         background:'#f7fcff',
                         float: 'left',
                   },
             "& .makeStyles-root-25 .MuiIconButton-root":{
                padding: '4px 0',
            },
            "& .MuiList-padding":{
                paddingTop:'10px !important',
            },
        },
}));

export default loginStyles;